<template>
    <div class="main_center lawEnforcement_detail">
        <div class="top-content">
            <div class="left-navbar">
                <el-button @click="backRouter">返回</el-button>
                <el-button @click="addDataList()" icon="el-icon-plus" size="medium" type="primary"  v-if="hasBtnPermission('credit_config_add')">新增评价项</el-button>
            </div>
        </div>
        <div class="right-content" style="padding-right: 24px">
            <el-tabs @tab-click="handleClick" style="height:16px;margin-left: 20px" v-model="activeName">
                <el-tab-pane label="打分评价" name="1"></el-tab-pane>
                <el-tab-pane label="选项评价（星级评价、是否、好中差等）" name="2"></el-tab-pane>
            </el-tabs>
            <div style="min-height:550px;padding:40px 0px 24px 20px">
                <el-tabs @tab-click="selectGroup" type="card"  v-if="activeName=='2'" v-model="level">
                    <el-tab-pane :key="index" :label="item.name" :name="item.level" v-for="(item,index) in groupList"></el-tab-pane>
                </el-tabs>
                <el-row>
<!--            <el-col :span="2" v-if="activeName=='2'">-->
<!--                <div style="padding-right: 10px;margin-top:60px">-->
<!--                    <el-menu @select="selectGroup" class="leftMenu" default-active="1" ref="leftmenu">-->
<!--                        <el-menu-item  :index="item.level" :key="index" v-for="(item,index) in groupList">{{item.name}}</el-menu-item>-->
<!--                    </el-menu>-->
<!--                </div>-->
<!--            </el-col>-->
                    <el-col :span="24">
                        <!-- :key="item.id" -->
                        <evalItem
                                @updateListItem="updateListItem"
                                :evalForm="item"
                                :evalFormIndex="index"
                                :key="index"
                                :level.sync="level"
                                :scoreValue="scoreValue"
                                :type.sync="activeName"
                                @deleteEvalItem="deleteDataList"
                                @reloadList="getDataList"
                                v-for="(item,index) in dataList">
                        </evalItem>
                    </el-col>
                </el-row>

            </div>


        </div>
    </div>
</template>
<script>
import {evalModeQueryList} from '@/server/entEval';
import evalItem from '../components/evalItem/index'
import { mapState } from "vuex";
export default {
    components: {
        evalItem
    },
    data() {
        return {
            activeName:'1',
            dataList:[],
            level:'0',
            scoreValue:0,
            groupList: [
                {
                    name:'二级满意度评价',
                    level:'1',
                    scoreValue:2,
                },
                {
                    name:'三级满意度评价',
                    level:'2',
                    scoreValue:3,
                },
                {
                    name:'五级满意度评价',
                    level:'3',
                    scoreValue:5,
                },
            ],
            form: {
                id: '',
                status: false,
                personType: '',
                participationRights: [],
            },
            rules: {
                status: [
                    { required: true, message: '请选择人员启用状态', trigger: ['blur'] }
                ],
                personType: [
                    { required: true, message: '请选择人员类型', trigger: ['blur', 'change'] }
                ],
                participationRights: [
                    { required: true, message: '请选择人员参与权限', trigger: ['blur', 'change'] }
                ],
            },
            type: 1,
            timeout: null,
        }
    },

    computed: {

    },
    watch: {

    },
    created() {

    },
    activated() {
        this.getDataList()
    },
    methods: {
        addDataList(){

            let optionConfigVos = [];
            for(var i =0;i<this.scoreValue;i++){
                optionConfigVos.push({
                    id:'',
                    name:'',
                    parentId:'',
                    value:'',
                    matchValue:0,
                    showUrl:'',
                    noShowUrl:'',
                })
            }

            this.dataList.push({
                id: '',
                openFlag:1,
                isEdit:true,
                remarkEdit:true,
                evaluateCode:"",
                evaluateName:"",
                min:"",
                max:"",
                step:"",
                fixed:"",
                remark:"",
                sort:'',
                iconType:1,
                halfStarFlag:0,
                scoreValue:this.scoreValue,
                showUrl:'',
                noShowUrl:'',
                optionConfigVos:optionConfigVos,
                type:this.activeName,
                level:this.level
            })

        },
        updateListItem(index,key,val,oldval){
            if(oldval){
                this.dataList[index]= oldval
            }else{
                this.dataList[index][key] = val;
            }
            this.dataList = JSON.parse(JSON.stringify(this.dataList))
        },
        deleteDataList(index){
            debugger
            if(index > -1){
                this.dataList.splice(index,1);
            }
            
            //取消新增后刷新页面
            this.getDataList()
        },
        getDataList() { // 获取列表数据
            this.dataListLoading=true;
            evalModeQueryList({
                page:1,
                rows:1000,
                filter:{
                    type:this.activeName == '1'?1:2,
                    level:parseInt(this.level),
                },
            }).then((res)=>{
                let dataRows = res.data.rows || [];
                dataRows.forEach((item)=>{
                    item.openFlag = item.openFlag?1:0;
                    let scoreRange = item.scoreRange?JSON.parse(item.scoreRange):{};
                    if(scoreRange){
                        item.min = scoreRange.min || 0;
                        item.max = scoreRange.max || 0;
                        item.step = scoreRange.step || 0;
                        item.fixed = scoreRange.fixed || 0;
                    }
                })
                this.dataList = dataRows;
            }).finally(()=>{})
        },


        selectGroup(tab) {
            this.level = tab.name;
            this.pageIndex = 1;
            const filter =  this.groupList.filter((item)=>item.level == tab.name)
            if(filter.length > 0){
                this.scoreValue = filter[0].scoreValue;
            }
            this.getDataList()
        },

        handleClick(tab) {
            if(tab.name == '1'){
                this.level = "0"
                this.scoreValue = 0;
            }else{
                this.level = "1"
                this.scoreValue = 2;
            }
            this.getDataList()

        },
        backRouter() {
            this.tabsCloseCurrent()
        },
   
        handlePersonType() {
            // this.form.personType = "";
        },
        handleDeptType(data) {
            this.form.deptCode = data.value;
            this.form.deptName = data.label;
        },
        uploadSuccess(fileType) {
            this.$refs['form'].clearValidate(['attachments' + fileType]);
        },

    }
}
</script>
<style lang="scss" scoped>


</style>